import { render } from "./AlertWarning.vue?vue&type=template&id=221ae508"
import script from "./AlertWarning.vue?vue&type=script&lang=js"
export * from "./AlertWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__